import React, { useState } from 'react';
import bcrypt from 'bcryptjs';
import '../App.css';

const UnlockTeam = ({ slug, teamName, passwordHash, onUnlocked }) => {
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const handleUnlock = async (e) => {
    e.preventDefault();
    setError('');

    const trimmedPassword = password.trim();

    if (!trimmedPassword) {
      setError('Upiši lozinku.');
      return;
    }

    if (!passwordHash) {
      setError('Tim nema spremljenu lozinku.');
      return;
    }

    setLoading(true);
    try {
      const ok = await bcrypt.compare(trimmedPassword, passwordHash);

      if (!ok) {
        setError('Pogrešna lozinka.');
        return;
      }

      localStorage.setItem(`team-unlocked:${slug}`, 'true');
      setPassword('');

      if (onUnlocked) onUnlocked();
    } catch (err) {
      console.error(err);
      setError('Greška pri otključavanju tima.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="settings-page">
      <div className="section-header">
        <h2><span role="img" aria-label="games">🔐</span> Tim je zaključan</h2>
        <span className="section-badge">{teamName || slug}</span>
      </div>

      <p style={{ color: 'var(--text-3)', marginBottom: 16 }}>
        Ovaj tim je vidljiv, ali za ulaz traži lozinku.
      </p>

      {error && <div className="form-error">{error}</div>}

      <form onSubmit={handleUnlock} className="settings-form" method="post" action="#" aria-label="Otključavanje tima">
        <div className="settings-field">
          <label htmlFor="unlock-team-password">Lozinka tima</label>
          <input
            id="unlock-team-password"
            name="team-password"
            type="password"
            autoComplete="off"
            className="input-field"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            placeholder="Upiši lozinku"
            autoFocus
            required
          />
        </div>

        <div className="form-actions">
          <button type="submit" className="btn btn-primary" disabled={loading}>
            {loading ? '⏳ Otključavam…' : '🔓 Otključaj tim'}
          </button>
        </div>
      </form>
    </div>
  );
};

export default UnlockTeam;